import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom'
import TouchBottom from '../shareComponent/touchBottom'

const index = lazy(() => import('../index'))
const search = lazy(() => import('../search'))
const category = lazy(() => import('../category'))
const notfound = lazy(() => import('../notfound'))
const recharge = lazy(() => import('../recharge'))
const rechargeInPage = lazy(() => import('../rechargeInPage'))
const minautumnrecharge = lazy(() => import('../midautumnrecharge'))
const qingmingrecharge = lazy(() => import('../qingmingrecharge'))
const wuyirecharge = lazy(() => import('../wuyirecharge'))
const dubleonecharge = lazy(() => import('../dubleonecharge'))
const payactivity = lazy(() => import('../payactivity'))
const payyear = lazy(() => import('../payyear'))
const paybigbag = lazy(() => import('../paybigbag'))
const rank = lazy(() => import('../rank'))
const mine = lazy(() => import('../mine'))
const recentlyread = lazy(() => import('../recentlyread'))
const feedback = lazy(() => import('../feedback'))
const packet = lazy(() => import('../packet'))
const balance = lazy(() => import('../balance'))
const signin = lazy(() => import('../signin'))
const menuSignin = lazy(() => import('../signin/menuSignin'))
const catalogue = lazy(() => import('../catalogue'))
const follow = lazy(() => import('../follow'))
const readpage = lazy(() => import('../readpage'))
const offlineBook = lazy(() => import('../offlineBook'))
const wuliulist = lazy(() => import('../wuliulist'))
const wuliuinfo = lazy(() => import('../wuliuinfo'))
const cj1 = lazy(() => import('../cj1'))
const libao = lazy(() => import('../libao'))
const tsPage = lazy(() => import('../tsPage'))
const fansFeedback = lazy(() => import('../fansFeedback'))
// const free = lazy(() => import('../free'))
const bookDetail = lazy(() => import('../bookDetail'))
const myShelf = lazy(() => import('../myShelf'))
const daystask = lazy(() => import('../daystask'))

// const qxsGetMoney = lazy(() => import('../quxiaoshuo/getMoney'))
const qxsGetMoneyNew = lazy(() => import('../quxiaoshuo/getMoneyNew'))
const qxsZJ = lazy(() => import('../quxiaoshuo/zj'))
const testInterface = lazy(() => import('../testInterface'))
const duanwurecharge = lazy(() => import('../duanwurecharge'))
const rotaryDraw = lazy(() => import('../rotaryDraw'))
const rotaryList = lazy(() => import('../rotaryList'))
const shubao = lazy(() => import('../shubao'))

const activeFirstDayForYear = lazy(() => import('../activeFirstDayForYear'))
const shareErCode = lazy(() => import('../shareErCode'))
const notFollow = lazy(() => import('../notFollow'))
const yearVip = lazy(() => import('../yearVip'))
const exclusiveBook = lazy(() => import('../exclusiveBook'))
const JkVip = lazy(() => import('../jkVip'))
const preferences = lazy(() => import('../preferences'))
const redPacketRule = lazy(() => import('../redPacketRule'))

function WaitingComponent(Component) {
    return props => (
        <Suspense fallback={<div></div>}>
            <Component {...props} />
        </Suspense>
    )
}

function onEnter(Component, props, withTouchBottom) {
    try{
        const parval = document.getElementById('parval')
        if (!!parval && parval.value === 1) {
            let val = parval.getAttribute('data-val')
            if (!!window.history && val.length > 0) {
                window.history.replaceState({}, '', '?' + val)
            }
            parval.remove()
        }
    } catch (e) {
        console.log(e)
    }
    try{
        if (!!window && window._czc) {
            const location = document.location
            const contentUrl = location.pathname + location.hash
            const refererUrl = '/'
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
    } catch (e) {
        console.log(e)
    }
    let curHref = ''
    try{
        curHref = document.location.href
    } catch (e) {
        console.log(e)
    }
    const component = withTouchBottom ? (
        <TouchBottom>
            <Component {...props} key={curHref} />
        </TouchBottom>
    ) : (
        <Component {...props} key={curHref} />
    )
    return component
}

export const App = () => (
    <Router>
        <Switch>
            <Route exact path={`/`} render={() => <Redirect to={`/index`}></Redirect>}></Route>
            <Route path={`/index`} render={props => onEnter(WaitingComponent(index), props)}/>{/* 首页 */}
            {/* 搜索 */}
            <Route path={`/search`} render={props => onEnter(WaitingComponent(search), props)}/>
            {/* 分类 */}
            <Route path={`/category`} render={props => onEnter(WaitingComponent(category), props)}/>
            <Route path={`/recharge/:bookId?`} render={props => onEnter(WaitingComponent(recharge), props)}/>{/* 充值 */}
            <Route path={`/rechargeInPage/:bookId?/:chapterId?`} render={props => onEnter(WaitingComponent(rechargeInPage), props)}/>{/* 页面内充值 */}
            <Route path={`/minautumnrecharge/:bookId?`} render={props => onEnter(WaitingComponent(minautumnrecharge), props)}/>{/* 中秋活动充值 */}
            <Route path={`/qingmingrecharge/:bookId?`} render={props => onEnter(WaitingComponent(qingmingrecharge), props)}/>{/* 清明活动充值 */}
            <Route path={`/duanwurecharge/:bookId?`} render={props => onEnter(WaitingComponent(duanwurecharge), props)}/>{/* 端午活动充值 */}
            <Route path={`/wuyirecharge/:bookId?`} render={props => onEnter(WaitingComponent(wuyirecharge), props)}/>{/* 五一活动充值 */}
            <Route path={`/dubleonecharge/:bookId?`} render={props => onEnter(WaitingComponent(dubleonecharge), props)}/>{/* 双11活动充值 */}
            <Route path={`/payactivity`} render={props => onEnter(WaitingComponent(payactivity), props)}/>{/* 充值活动 */}
            <Route path={`/payyear`} render={props => onEnter(WaitingComponent(payyear), props)}/>{/* 新春充值活动 */}
            <Route path={`/paybigbag`} render={props => onEnter(WaitingComponent(paybigbag), props)}/>{/* 充值活动2 */}
            <Route path={`/rank`} render={props => onEnter(WaitingComponent(rank), props)}/>{/* 排行榜 */}
            <Route path={`/mine`} render={props => onEnter(WaitingComponent(mine), props)}/>{/* 个人中心 */}
            <Route path={`/recentlyread`} render={props => onEnter(WaitingComponent(recentlyread), props, true)}/>{/* 最近阅读 */}
            <Route path={`/feedback`} render={props => onEnter(WaitingComponent(feedback), props)}/>{/* 反馈 */}
            <Route path={`/packet`} render={props => onEnter(WaitingComponent(packet), props)}/>{/* 红包 */}
            <Route path={`/redPacketRule`} render={props => onEnter(WaitingComponent(redPacketRule), props)}/>{/* 书币红包规则 */}
            <Route path={`/balance`} render={props => onEnter(WaitingComponent(balance), props)}/>{/* 消费记录 */}
            <Route path={`/signin`} render={props => onEnter(WaitingComponent(signin), props)}/>{/* 签到 */}
            <Route path={`/menuSignin`} render={props => onEnter(WaitingComponent(menuSignin), props)}/>{/* 小程序签到 */}
            <Route path={`/catalogue/:bookId`} render={props => onEnter(WaitingComponent(catalogue), props)}/>{/* 目录 */}
            <Route path={`/follow`} render={props => onEnter(WaitingComponent(follow), props)}/>{/* 关注中转页面 */}
            <Route path={`/offlineBook`} render={props => onEnter(WaitingComponent(offlineBook), props)}/>{/* 下线书 */}
            <Route path={`/wuliulist`} render={props => onEnter(WaitingComponent(wuliulist), props)}/>{/* 物流列表 */}
            <Route path={`/tsPage/:bookId/:contentId`} render={props => onEnter(WaitingComponent(tsPage), props)}/>{/* 投诉页面 */}
            <Route path={`/wuliuinfo/:giftid?`} render={props => onEnter(WaitingComponent(wuliuinfo), props)}/>{/* 物流详情 */}
            <Route path={`/cj1/:draw_record_id?`} render={props => onEnter(WaitingComponent(cj1), props)}/>{/* 物流详情 */}
            <Route path={`/libao/:fee?`} render={props => onEnter(WaitingComponent(libao), props)}/>{/* 礼包 */}
            <Route path={`/readpage/:bookId/:contentId/:payed?`} render={props => onEnter(WaitingComponent(readpage), props)}/>{/* 阅读页 */}
            <Route path={`/content/:bookId/:contentId/:payed?`} render={props => onEnter(WaitingComponent(readpage), props)}/>{/* 阅读页 */}
            <Route path={`/bookContent/:bookId/:contentId/:payed?`} render={props => onEnter(WaitingComponent(readpage), props)}/>{/* 阅读页 */}
            <Route path={`/bookReadPage/:bookId/:contentId/:payed?`} render={props => onEnter(WaitingComponent(readpage), props)}/>{/* 阅读页 */}
            <Route path={`/bookText/:bookId/:contentId/:payed?`} render={props => onEnter(WaitingComponent(readpage), props)}/>{/* 阅读页 */}
            {/* 幸运抽大奖 */}
            <Route path={`/rotaryDraw`} render={props => onEnter(WaitingComponent(rotaryDraw), props)}/>
            <Route path={`/jkvip`} render={props => onEnter(WaitingComponent(JkVip), props)}/>
            <Route path={`/rotaryList`} render={props => onEnter(WaitingComponent(rotaryList), props)}/>{/* 幸运抽大奖获奖列表 */}
            <Route path={`/shubao`} render={props => onEnter(WaitingComponent(shubao), props)}/>{/* 书包 */}
            <Route path={`/daystask`} render={props => onEnter(WaitingComponent(daystask), props)}/>{/* 每日任务 */}
            {/* 趣小说 */}
            {/*<Route path={`/quxiaoshuo/getMoney`} render={props => onEnter(WaitingComponent(qxsGetMoney), props)}/>/!* 领钱 *!/*/}
            <Route path={`/quxiaoshuo/getMoneyNew`} render={props => onEnter(WaitingComponent(qxsGetMoneyNew), props)}/>{/* 领钱 */}
            <Route path={`/quxiaoshuo/zj`} render={props => onEnter(WaitingComponent(qxsZJ), props)}/>{/* 中间跳转页面 */}
            <Route path={`/activeFirstDayForYear`} render={props => onEnter(WaitingComponent(activeFirstDayForYear), props)}/>{/* 元旦活动页面 */}
            {/* 测试 */}
            <Route path={`/testInterface`} render={props => onEnter(WaitingComponent(testInterface), props)}/>{/* 接口测试 */}
            <Route path={`/fansFeedback`} render={props => onEnter(WaitingComponent(fansFeedback), props)}/>{/* 反馈 */}
            {/* 限时免费 */}
            {/* <Route path={`/free`} render={props => onEnter(WaitingComponent(free), props)}/> */}
            <Route path={`/bookDetail/:bookId`} render={props => onEnter(WaitingComponent(bookDetail), props)}/>{/* 书籍详情 */}
            <Route path={`/myShelf`} render={props => onEnter(WaitingComponent(myShelf), props)}/>{/* 我的书架 */}
            <Route path={`/userShelf`} render={props => onEnter(WaitingComponent(myShelf), props)}/>{/* 我的书架 */}
            <Route path={`/meShelf`} render={props => onEnter(WaitingComponent(myShelf), props)}/>{/* 我的书架 */}
            <Route path={`/shareErCode`} render={props => onEnter(WaitingComponent(shareErCode), props)}/>{/* 分享二维码 */}
            <Route path={`/notFollow`} render={props => onEnter(WaitingComponent(notFollow), props)}/>{/* 分享二维码 */}
            <Route path={`/yearVip`} render={props => onEnter(WaitingComponent(yearVip), props)}/>{/* 365年费活动中间页 */}
            <Route path={`/exclusiveBook`} render={props => onEnter(WaitingComponent(exclusiveBook), props)}/>{/* 专属书单 */}
            <Route path={`/preferences`} render={props => onEnter(WaitingComponent(preferences), props)}/>{/* 偏好设置 */}

            <Route component={notfound}/>{/* 404页面 */}
        </Switch>
    </Router>
)

export default App